
import LineHeight from "../../../assets/filled/LineHeight.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LineHeightIcon({ className, dataTestid = "LineHeightIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <LineHeight data-testid={dataTestid} className={classes} {...rest} />
  );
}
